// Boards Module
import firebase from '@/api/config/FirebaseConfig'
import FirebaseAPI from '@/api/firebase'
import ForeplayAPI from '@/api/foreplayServer'

import { getBoards } from '../../db/BoardsDB'
import { getFolders } from '../../db/FoldersDB'

export default {
  namespaced: true,
  state: {
    boards: [],
    folders: [],
    teamBoards: [],
    initialFoldersLoaded: false
  },
  getters: {
    // Get Boards
    getBoards: (state) => state.boards,
    // Get Folders
    getFolders: (state) => state.folders,
    getInitialFoldersLoaded: (state) => state.initialFoldersLoaded
  },
  mutations: {
    SET_BOARDS (state, boards) {
      state.boards = boards
    },
    SET_FOLDERS (state, folders) {
      state.folders = folders
    },
    SET_INITIAL_FOLDERS_LOADED (state) {
      state.initialFoldersLoaded = true
    }
  },
  actions: {
    async fetchFolders ({ commit }) {
      const userTeam = await FirebaseAPI.Teams.getUserTeam()

      const fetchFoldersFunction = async () => {
        // If the user is on a team get the team folders
        if (userTeam) {
          const folders = await FirebaseAPI.Folders.getAllByTeam(userTeam.id)
          return folders.sort((a, b) => (a.name > b.name ? 1 : -1))
        }

        // Get a users folders
        const folders = await FirebaseAPI.Folders.getAllByUser()
        return folders.sort((a, b) => (a.name > b.name ? 1 : -1))
      }

      const result = await getFolders(fetchFoldersFunction)

      // Set initial cached data
      commit('SET_FOLDERS', result.cached)

      // Update with fresh data when it arrives
      const freshData = await result.fresh
      commit('SET_FOLDERS', freshData)

      commit('SET_INITIAL_FOLDERS_LOADED', true)
    },
    // Fetch Boards
    async fetchBoards ({ commit, rootState }, team = null) {
      const authTeam = rootState.AuthModule.team
      const userTeam = authTeam ? team || authTeam : await FirebaseAPI.Teams.getUserTeam()

      const fetchBoardsFunction = async () => {
        const boards = userTeam
          ? await FirebaseAPI.Boards.getAllByTeam(userTeam.id)
          : await FirebaseAPI.Boards.getAllByUser()

        if (!firebase.auth().currentUser) {
          return boards.sort((a, b) => (a.name > b.name ? 1 : -1))
        }

        // Get the ad count for each board
        const adCounts = await ForeplayAPI.Ads.getBoardsAdCount(
          userTeam ? userTeam.id : undefined
        )
        const boardsWithAdCount = boards.map((board) => ({
          ...board,
          adCount:
            adCounts.find((adCount) => adCount.key === board.id)?.doc_count ||
            0
        }))
        return boardsWithAdCount.sort((a, b) => (a.name > b.name ? 1 : -1))
      }

      const result = await getBoards(fetchBoardsFunction)

      // Set initial cached data
      commit('SET_BOARDS', result.cached)

      // Update with fresh data when it arrives
      const freshData = await result.fresh
      commit('SET_BOARDS', freshData)
    }
  }
}
